/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInKeyPublicPem: core.serialization.ObjectSchema<
    serializers.NotInKeyPublicPem.Raw,
    Truvity.NotInKeyPublicPem
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NotInKeyPublicPem {
    export interface Raw {
        values: string[];
    }
}
